/**
 * RadioFieldType — pojedynczy wybór z listy opcji (alternatywa dla select gdy mało opcji).
 * Storage: PG TEXT.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function RadioInput({ field, value, onChange, error, disabled }: FieldInputProps) {
  const options = field.options ?? [];
  const stringValue = typeof value === 'string' ? value : '';
  return (
    <div
      role="radiogroup"
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="space-y-1.5"
    >
      {options.map((opt) => (
        <label key={opt.value} className="flex items-center gap-2 text-sm">
          <input
            type="radio"
            name={field.slug}
            value={opt.value}
            checked={stringValue === opt.value}
            onChange={() => onChange(opt.value)}
            disabled={disabled}
            className="h-4 w-4 border-border-primary text-accent-600 focus:ring-accent-500"
          />
          <span className="text-text-secondary">{opt.label}</span>
        </label>
      ))}
    </div>
  );
}

export const RadioFieldType: FieldTypeDefinition = {
  type: 'radio',
  renderInput: (props) => <RadioInput {...props} />,
  renderCell: (field, value) => {
    if (typeof value !== 'string' || !value) return '';
    return field.options?.find((o) => o.value === value)?.label ?? value;
  },
  defaultValue: null,
};
